import React, { useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth.jsx';
import InputField from '../Form/InputField';
import Button from '../Form/Button';
import { ERROR_MESSAGES } from '../../utils/constants';
import icon from '@/utils/icon.js';

const LoginBox = ({ onSuccess, onSwitchToRegister, onSwitchToForgot, showCloseBtn = false, onClose }) => {
  const [formData, setFormData] = useState({
    account: '',
    psw: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!formData.account) {
      setError(ERROR_MESSAGES.EMPTY_ACCOUNT);
      setLoading(false);
      return;
    }

    if (!formData.psw) {
      setError(ERROR_MESSAGES.EMPTY_PASSWORD);
      setLoading(false);
      return;
    }

    try {
      await login(formData.account, formData.psw);
      
      if (onSuccess) {
        onSuccess();
      } else {
        // 默认跳转逻辑
        const from = location.state?.from || '/user';
        navigate(from, { replace: true });
      }
    } catch (err) {
      setError(err.message || ERROR_MESSAGES.NETWORK_ERROR);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value
    });
    setError('');
  };

  return (
    <div className="relative w-full max-w-sm bg-[#1A1C1B] border border-white/20 rounded-xl p-8 text-white pt-[24px]">
      <img src={icon.moldAISvg2} className='h-9'></img>
      {showCloseBtn && (
        <button 
          onClick={onClose}
          className="absolute top-7 right-6 text-white/40 hover:text-white transition-colors"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      )}

      <h1 className="text-2xl font-medium mb-8">欢迎使用Moldia</h1>

      <form className="space-y-6" onSubmit={handleSubmit}>
        <InputField
          type="tel"
          placeholder="手机号"
          id="account"
          name="account"
          autoComplete="username"
          value={formData.account}
          onChange={handleChange}
        />
        <InputField
          type="password"
          placeholder="密码"
          id="psw"
          name="password"
          autoComplete="current-password"
          value={formData.psw}
          onChange={handleChange}
        />

        {error && (
          <span className="login_error text-left text-sm text-rose-500 block">
            {error}
          </span>
        )}

        <div className="text-right text-sm text-gray-400">
          {onSwitchToForgot ? (
            <button 
              type="button"
              onClick={onSwitchToForgot} 
              className="hover:text-gray-200 cursor-pointer"
            >
              忘记密码?
            </button>
          ) : (
            <Link to="/forgot-password" className="hover:text-gray-200 cursor-pointer">
              忘记密码?
            </Link>
          )}
        </div>

        <Button type="submit" disabled={loading}>
          {loading ? '登录中...' : '登录'}
        </Button>
      </form>

      <div className="flex items-center my-6">
        <div className="flex-grow h-px bg-gray-700"></div>
        <span className="mx-3 text-sm text-gray-500">OR</span>
        <div className="flex-grow h-px bg-gray-700"></div>
      </div>

      <div className="text-center text-sm text-gray-400">
        没有账号?
        {onSwitchToRegister ? (
          <button 
            type="button"
            onClick={onSwitchToRegister} 
            className="text-[#61EA3C] hover:underline ml-1"
          >
            注册
          </button>
        ) : (
          <Link to="/register" className="text-[#61EA3C] hover:underline ml-1">
            注册
          </Link>
        )}
      </div>
    </div>
  );
};

export default LoginBox;
